import { render, staticRenderFns } from "./BeginningChallenge.vue?vue&type=template&id=02331cb4"
import script from "./BeginningChallenge.vue?vue&type=script&lang=js"
export * from "./BeginningChallenge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports